import { render } from "./DetActivites.vue?vue&type=template&id=bd161490&scoped=true"
import script from "./DetActivites.vue?vue&type=script&lang=js"
export * from "./DetActivites.vue?vue&type=script&lang=js"

import "./DetActivites.vue?vue&type=style&index=0&id=bd161490&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd161490"]])

export default __exports__